import type {
  AvailabilitiesPlaceMapDTO,
  FloorPlanIconsDTO,
} from '@/types/dto/agent';
import { createContext } from 'react';

export interface SeatSelectionContextValue {
  selectedLegId?: string;
  selectedReservationId?: string;
  selectedCarriageIndex: number;
  selectedFloorIndex: number;
  isLoading: boolean;
  isUndoing: boolean;
  availabilitiesPlaceMap?: AvailabilitiesPlaceMapDTO;
  floorPlanIcons: FloorPlanIconsDTO | undefined;
  currentPlaceMap:
    | NonNullable<AvailabilitiesPlaceMapDTO['placeMaps']>[number]
    | null;
  seatSelectionSuccess: boolean;
  seatSelectionError: boolean;
  setSelectedCarriageIndex: (index: number) => void;
  setSelectedFloorIndex: (index: number) => void;
  setIsUndoing: (open: boolean) => void;
  handleLegSelect: (legId: string) => Promise<void>;
  handleSeatSelect: (placeId: string) => void;
  handleReservationSelect: (reservationId: string) => void;
  handlePassengerSeatClick: (placeId: string, reservationId: string) => void;
  closeModal: () => void;
  refreshPlaceAvailability: () => Promise<void>;
}

export const SeatSelectionContext = createContext<
  SeatSelectionContextValue | undefined
>(undefined);
